/* The Terms window on a printed document's page (piece 22; decision 0684): the clauses in force, then the document's own text. */

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.heading {
  margin: 0;
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
}

.clauses {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-height: 40vh;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}

.clause {
  display: flex;
  flex-direction: column;
  gap: var(--space-half);
  padding: var(--space-1) 0;
  border-bottom: 1px solid var(--surface-2);
}

.clauseTitle {
  font-weight: var(--font-weight-semibold);
}

.own {
  margin: 0;
}

.muted {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

.frozen {
  margin: 0;
  padding: var(--space-2);
  border-radius: var(--radius-small);
  background: var(--status-warning-bg);
  color: var(--status-warning-text);
}

/* A section's heading before its first clause (decision 0702). */
.sectionHeading {
  padding-top: var(--space-1);
  color: var(--text-muted);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-semibold);
}

/* A sub-section's heading inside its section, before its first clause (decision 0771). */
.subHeading {
  padding-left: var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-semibold);
}

/* 🔒 The line saying the terms listed are the ones the document went out with (decision 0773). */
.asSent {
  margin: 0;
  padding: var(--space-2);
  border-radius: var(--radius-small);
  background: var(--surface-2);
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

/* The copy a version list's entry opens: its lines, one row each (decision 0773). */
.copyLines {
  display: flex;
  flex-direction: column;
  gap: var(--space-half);
  margin: 0;
  padding: 0;
  list-style: none;
}

.copyLine {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-half) 0;
  border-bottom: 1px solid var(--surface-2);
}

.copyTotal {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-1);
  margin: 0;
  font-weight: var(--font-weight-semibold);
}

/* A clause a confidentiality role added (decision 1171): named, because nothing on the window removes it. */
.addition {
  align-self: flex-start;
  padding: 0 var(--space-1);
  border-radius: var(--radius-small);
  background: var(--status-warning-bg);
  color: var(--status-warning-text);
  font-size: var(--font-size-caption);
}
